const Video = {
    init: () => {
        console.log("video init")
    }
}

export default Video